import React from 'react'
import { BiBarChart, BiShield, BiCog } from 'react-icons/bi'
import FeatureItem from './FeatureItem'

const FeatureList = () => (
    <div className="space-y-4">
        <FeatureItem 
            icon={BiBarChart}
            title="Dashboard Operacional"
            description="Acompanhe dados diários"
        />
        <FeatureItem 
            icon={BiShield}
            title="Acesso Controlado"
            description="Apenas para funcionários"
        />
        <FeatureItem 
            icon={BiCog}
            title="Ferramentas Internas"
            description="Gestão e controle"
        />
    </div>
)

export default FeatureList